export const environment = {
    production: false,
    apiUrl: 'https://teampage-dev.gprddigital.com/api',
    baseUrl: 'http://localhost:4000',
};
